import { useCampaignsShow } from '@jobilla/nexus-sdk'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNewFormEditor, usePostLaunchBrandingLoader, usePostLaunchLandingPageEditor } from '../../../../../hooks'
import { BackArrowIcon, PostLaunchFormEditorShell } from '../../../../../ui'

export const Route = createFileRoute(
	'/_auth/company/$companyId/$campaignId/form-editor',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const { t } = useTranslation('common')
	const { campaignId, companyId } = Route.useParams()
	const navigate = useNavigate()

	// Load campaign to check status
	const campaign = useCampaignsShow(campaignId)
	const campaignStatus = campaign.data?.status

	// Redirect away if campaign is draft or completed
	useEffect(() => {
		if (campaign.isLoading) { return }

		// Only allow editing for review and active campaigns
		if (campaignStatus === 'draft') {
			// Redirect to the main editor for draft campaigns
			void navigate({
				to: '/company/$companyId/campaign/$campaignId',
				params: { companyId, campaignId },
				replace: true,
			})
		} else if (campaignStatus === 'completed') {
			// Redirect to overview for completed campaigns
			void navigate({
				to: '/company/$companyId/$campaignId/overview',
				params: { companyId, campaignId },
				replace: true,
			})
		}
	}, [campaign.isLoading, campaignStatus, campaignId, companyId, navigate])

	// Initialize data hydration hooks
	const { isPending: isBrandingPending } = usePostLaunchBrandingLoader(campaignId)
	const { isPending: isFormPending } = useNewFormEditor(campaignId, { postLaunch: true })
	const { isPending: isLandingPagePending } = usePostLaunchLandingPageEditor(campaignId)

	const isLoading = isBrandingPending || isFormPending || isLandingPagePending

	const backButton = (
		<Link
			to="/company/$companyId/$campaignId/overview"
			params={{ companyId, campaignId }}
			className="flex items-center gap-2 text-grey-600 hover:text-grey-900 transition-colors"
		>
			<BackArrowIcon />
			<span className="text-sm font-medium">{t('postLaunch.backToOverview')}</span>
		</Link>
	)

	return (
		<div className="fixed inset-0 z-50 bg-white">
			<PostLaunchFormEditorShell
				isLoading={isLoading}
				backButton={backButton}
				campaignId={campaignId}
			/>
		</div>
	)
}
